{
  "quick_reactions": ["👍", "❤️", "😂", "😮", "😢", "🙏"],
  "emoji_list": [
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😅",
    "😂",
    "🤣",
    "🙂",
    "😉",
    "😊",
    "😍",
    "🥰",
    "😘",
    "😋",
    "😎",
    "🤩",
    "🥳",
    "😏",
    "😴",
    "🤤",
    "😇",
    "🤔",
    "🤨",
    "😐",
    "😬",
    "🙄",
    "😮",
    "😯",
    "😲",
    "🥺",
    "😢",
    "😭",
    "😤",
    "😡",
    "🤬",
    "🤯",
    "😱",
    "😨",
    "😳",
    "🥵",
    "🥶",
    "😵",
    "🤢",
    "🤮",
    "🤧",
    "😷",
    "🤐",
    "💩",
    "👍",
    "👎",
    "🖕",
    "👌",
    "✌️",
    "🤞",
    "🤟",
    "🤘",
    "🤙",
    "👏",
    "🙌",
    "🙏",
    "💪",
    "👀",
    "🫶",
    "🤝",
    "🫡",
    "❤️",
    "🧡",
    "💛",
    "💚",
    "💙",
    "💜",
    "🖤",
    "🤍",
    "💔",
    "❤️‍🔥",
    "💕",
    "💞",
    "💖",
    "💘",
    "💯",
    "✨",
    "🔥",
    "🌟",
    "⭐",
    "🌈",
    "☀️",
    "🌙",
    "⚡",
    "🌸",
    "🌹",
    "🌻",
    "🍀",
    "🌵",
    "🐶",
    "🐱",
    "🦊",
    "🐻",
    "🐼",
    "🦁",
    "🐮",
    "🐷",
    "🐵",
    "🐔",
    "🦄",
    "🐝",
    "🦋",
    "🐢",
    "🐙",
    "🦖",
    "🍏",
    "🍎",
    "🍌",
    "🍉",
    "🍓",
    "🍒",
    "🍑",
    "🥑",
    "🍆",
    "🍔",
    "🍟",
    "🍕",
    "🌮",
    "🍿",
    "🍩",
    "🎂",
    "🍰",
    "🍫",
    "🍬",
    "🍺",
    "🍻",
    "🥂",
    "🍷",
    "☕",
    "⚽",
    "🏀",
    "🏈",
    "🎾",
    "🎮",
    "🎲",
    "🎯",
    "🎉",
    "🎊",
    "🎁",
    "🏆",
    "🥇",
    "🎵",
    "🎸",
    "📱",
    "💻",
    "💡",
    "📌",
    "✅",
    "❌",
    "❗",
    "❓",
    "💤",
    "👋"
  ]
}
